import * as CONST from '../ActionTypes';

const initialState = {
  isSuccess: false,
  isFailure: false,
  errorMessage: '',
  ecCommercialTransactionLaw: {},
  ecCommercialTransactionLawList: [],
};

function ecCommercialTransactionLaw(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // EC情報一覧取得
    // -----------------
    case CONST.GET_EC_COMMERCIAL_TRANSACTION_LAW_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          ecCommercialTransactionLawList: action.payload,
        },
      );
    case CONST.GET_EC_COMMERCIAL_TRANSACTION_LAW_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          isFailure: true,
          ecCommercialTransactionLawList: {},
        },
      );
    // -----------------
    // 結果フラグクリア
    // -----------------
    case CONST.CLEAR_DELETE_EC_COMMERCIAL_TRANSACTION_LAW_RESULT_FLG:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: false,
          errorMessage: '',
        },
      );
    default:
      return state;
  }
}

export default ecCommercialTransactionLaw;
